// Records through the shared diagnostics logger, so these lines reach a bug
// report even from a production build; it prints them only in development.
// Debug lines are kept only while localStorage's debug_logging is "true".

import { createLogger } from "@jkast90/kast-common/diagnostics";

const debug = () => {
  try {
    return localStorage.getItem("debug_logging") === "true";
  } catch {
    return false;
  }
};

const base = createLogger({ debug });
const auth = createLogger({ category: "AUTH" });
const workflow = createLogger({ category: "Workflow" });

export const logger = {
  ...base,
  auth: auth.info,
  workflowStart: (name: string, context?: unknown) =>
    workflow.info(`START: ${name}`, context ?? ""),
  workflowFinish: (name: string, context?: unknown) =>
    workflow.info(`FINISH: ${name}`, context ?? ""),
  workflowError: (name: string, error: unknown, context?: unknown) =>
    workflow.error(`ERROR: ${name}`, error, context ?? ""),
};

export default logger;
